export * from './app-sidebar-form.component';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/components/app-sidebar-form/index.ts